(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dual-media"] && !Shopify.designMode) return;
  try {
    
  class DualMediaSection extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.videoTrigger = this.querySelector('.video-trigger');
      this.modal = document.getElementById(`video-modal-${this.sectionId}`);
      this.closeButtons = this.modal?.querySelectorAll('[data-close-modal]');
      this.videoPlayer = this.modal?.querySelector('.modal-video-player');
      this.scrollText = this.querySelector('[data-scroll-text]');
      
      this.init();
    }

    init() {
      // Video modal functionality
      if (this.videoTrigger && this.modal) {
        this.videoTrigger.addEventListener('click', () => this.openModal());
        
        this.closeButtons?.forEach(btn => {
          btn.addEventListener('click', () => this.closeModal());
        });
      }

      // Scroll animation for text
      if (this.scrollText) {
        this.initScrollAnimation();
      }
    }

    openModal() {
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      
      // Play video when modal opens
      if (this.videoPlayer) {
        this.videoPlayer.play();
      }
    }

    closeModal() {
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      
      // Pause video when modal closes
      if (this.videoPlayer) {
        this.videoPlayer.pause();
        this.videoPlayer.currentTime = 0;
      }
    }

    initScrollAnimation() {
      const rightSection = this.querySelector('.dual-media__right');
      const buttonContainer = this.querySelector('.right-button-container');
      if (!rightSection || !this.scrollText) return;

      // Get the scroll start offset from data attribute
      const scrollStartOffset = parseInt(this.scrollText.dataset.scrollStart || '0');
      
      let ticking = false;

      const updateTextPosition = () => {
        const rect = rightSection.getBoundingClientRect();
        const sectionHeight = rect.height;
        const viewportHeight = window.innerHeight;
        
        // Calculate how much we've scrolled into the section
        const scrolledIntoSection = viewportHeight - rect.top;
        
        // Only start animating after the scroll start offset
        if (scrolledIntoSection < scrollStartOffset) {
          // Haven't reached start offset yet, keep at starting position
          this.scrollText.style.setProperty('--text-position', '5%');
          ticking = false;
          return;
        }
        
        // Calculate the button's position relative to the section
        let stopPosition = sectionHeight * 0.75; // Default stop at 75% of section height
        if (buttonContainer) {
          const buttonRect = buttonContainer.getBoundingClientRect();
          const buttonPadding = parseInt(getComputedStyle(buttonContainer).getPropertyValue('--button-padding') || '30');
          
          // Calculate where the button is within the section
          const buttonTopInSection = sectionHeight - buttonRect.height - buttonPadding - 80;
          stopPosition = buttonTopInSection;
        }
        
        // Calculate text position based on scroll
        // The text follows the viewport top edge
        const distanceFromViewportTop = scrolledIntoSection - scrollStartOffset;
        
        // Convert to percentage of section height
        let textPositionInSection = ((distanceFromViewportTop) / sectionHeight) * 100;
        
        // Start at 5%, but clamp to stop position
        const startPos = 5;
        const maxPosPercent = (stopPosition / sectionHeight) * 100;
        
        textPositionInSection = Math.max(startPos, Math.min(maxPosPercent, startPos + textPositionInSection));
        
        this.scrollText.style.setProperty('--text-position', `${textPositionInSection}%`);
        
        ticking = false;
      };
      
      const requestTick = () => {
        if (!ticking) {
          requestAnimationFrame(updateTextPosition);
          ticking = true;
        }
      };

      window.addEventListener('scroll', requestTick, { passive: true });
      window.addEventListener('resize', () => {
        requestTick();
      }, { passive: true });
      
      updateTextPosition(); // Initial position
    }
  }

  customElements.define('dual-media-section', DualMediaSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.instagram-feed-section[data-access-token]');
    
    sections.forEach(section => {
      new InstagramFeedHandler(section);
    });
  });

  class InstagramFeedHandler {
    constructor(element) {
      this.element = element;
      this.track = this.element.querySelector('.instagram-feed-carousel .instagram-feed-track');
      this.placeholder = this.element.querySelector('.instagram-feed-placeholder');
      this.carousel = this.element.querySelector('.instagram-feed-carousel');
      this.nav = this.element.querySelector('.instagram-feed-nav');
      this.loading = this.element.querySelector('.instagram-feed-loading');
      this.error = this.element.querySelector('.instagram-feed-error');
      this.prevBtn = this.element.querySelector('.instagram-nav-prev');
      this.nextBtn = this.element.querySelector('.instagram-nav-next');
      this.accessToken = this.element.dataset.accessToken;
      this.postLimit = parseInt(this.element.dataset.postLimit) || 8;
      this.currentIndex = 0;
      this.itemsPerView = 4;
      this.posts = [];
      
      this.init();
    }

    async init() {
      // Setup navigation for placeholder
      this.setupNavigation('.instagram-feed-placeholder');
      
      // If token provided, fetch live feed
      if (this.accessToken && this.accessToken.trim() !== '') {
        await this.fetchInstagramFeed();
      }
    }

    async fetchInstagramFeed() {
      try {
        // Hide placeholder, show loading
        if (this.placeholder) this.placeholder.style.display = 'none';
        if (this.loading) this.loading.style.display = 'block';
        
        const url = `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url,timestamp&access_token=${this.accessToken}&limit=${this.postLimit}`;
        
        const response = await fetch(url);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.error) {
          throw new Error(data.error.message);
        }
        
        this.posts = data.data || [];
        
        if (this.posts.length === 0) {
          throw new Error('No Instagram posts found.');
        }
        
        this.renderPosts();
        this.setupNavigation('.instagram-feed-carousel');
        this.showFeed();
        
      } catch (error) {
        console.error('Instagram feed error:', error);
        this.showError(`Failed to load Instagram feed: ${error.message}`);
      }
    }

    renderPosts() {
      if (!this.track) return;
      
      this.track.innerHTML = '';
      
      this.posts.forEach(post => {
        const item = document.createElement('div');
        item.className = 'instagram-feed-item';
        
        const link = document.createElement('a');
        link.href = post.permalink;
        link.target = '_blank';
        link.rel = 'noopener';
        link.className = 'instagram-feed-link';
        
        const img = document.createElement('img');
        
        if (post.media_type === 'VIDEO') {
          img.src = post.thumbnail_url || post.media_url;
        } else {
          img.src = post.media_url;
        }
        
        img.alt = post.caption ? post.caption.substring(0, 100) : 'Instagram post';
        img.className = 'instagram-feed-image';
        img.loading = 'lazy';
        
        link.appendChild(img);
        item.appendChild(link);
        this.track.appendChild(item);
      });
    }

    setupNavigation(containerSelector) {
      this.prevBtn?.addEventListener('click', () => this.navigate('prev', containerSelector));
      this.nextBtn?.addEventListener('click', () => this.navigate('next', containerSelector));

      window.addEventListener('resize', () => this.updateItemsPerView(containerSelector));
      this.updateItemsPerView(containerSelector);
    }

    updateItemsPerView(containerSelector) {
      const width = window.innerWidth;
      if (width < 750) {
        this.itemsPerView = 2;
      } else if (width < 990) {
        this.itemsPerView = 3;
      } else {
        this.itemsPerView = 4;
      }
      this.updatePosition(containerSelector);
    }

    navigate(direction, containerSelector) {
      const container = this.element.querySelector(containerSelector);
      if (!container) return;
      
      const items = container.querySelectorAll('.instagram-feed-item');
      const maxIndex = Math.max(0, items.length - this.itemsPerView);
      
      if (direction === 'prev') {
        this.currentIndex = Math.max(0, this.currentIndex - 1);
      } else {
        this.currentIndex = Math.min(maxIndex, this.currentIndex + 1);
      }
      
      this.updatePosition(containerSelector);
      this.updateButtons(containerSelector);
    }

    updatePosition(containerSelector) {
      const container = this.element.querySelector(containerSelector);
      if (!container) return;
      
      const track = container.querySelector('.instagram-feed-track');
      const items = container.querySelectorAll('.instagram-feed-item');
      
      if (!track || items.length === 0) return;
      
      const itemWidth = items[0].offsetWidth;
      const gap = 16;
      const offset = this.currentIndex * (itemWidth + gap);
      
      track.style.transform = `translateX(-${offset}px)`;
    }

    updateButtons(containerSelector) {
      const container = this.element.querySelector(containerSelector || '.instagram-feed-placeholder');
      if (!container) return;
      
      const items = container.querySelectorAll('.instagram-feed-item');
      const maxIndex = Math.max(0, items.length - this.itemsPerView);
      
      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentIndex === 0;
      }
      
      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentIndex >= maxIndex;
      }
    }

    showFeed() {
      if (this.loading) this.loading.style.display = 'none';
      if (this.error) this.error.style.display = 'none';
      if (this.placeholder) this.placeholder.style.display = 'none';
      if (this.carousel) this.carousel.style.display = 'block';
      this.updateButtons('.instagram-feed-carousel');
    }

    showError(message) {
      if (this.loading) this.loading.style.display = 'none';
      if (this.carousel) this.carousel.style.display = 'none';
      if (this.placeholder) this.placeholder.style.display = 'block';
      if (this.error) {
        this.error.style.display = 'block';
        const errorText = this.error.querySelector('p');
        if (errorText) errorText.textContent = message;
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-highlights"] && !Shopify.designMode) return;
  try {
    
  class ProductHighlightSection extends HTMLElement {
    constructor() {
      super();
      this.scrollText = this.querySelector('[data-scroll-text]');
      this.container = this.querySelector('.product-highlight-container');
      this.productMedia = this.querySelector('.product-media-container');

      // Initialize scroll animation
      if (this.scrollText) {
        this.initScrollAnimation();
      }

      // Product hover effect
      if (this.productMedia && this.productMedia.dataset.enableHover === 'true') {
        this.productMedia.addEventListener('mouseenter', () => this.showSecondaryMedia());
        this.productMedia.addEventListener('mouseleave', () => this.hideSecondaryMedia());
      }
    }

    initScrollAnimation() {
      const productSection = this.querySelector('.product-side');
      if (!productSection || !this.scrollText) return;

      // Get the scroll start offset and stop position from data attributes
      const scrollStartOffset = parseInt(this.scrollText.dataset.scrollStart || '0');
      const scrollStopPosition = parseInt(this.scrollText.dataset.scrollStop || '80');
      
      let ticking = false;

      const updateTextPosition = () => {
        const rect = this.container.getBoundingClientRect();
        const sectionHeight = rect.height;
        const viewportHeight = window.innerHeight;
        
        // Calculate how much we've scrolled into the section
        const scrolledIntoSection = viewportHeight - rect.top;
        
        // Only start animating after the scroll start offset
        if (scrolledIntoSection < scrollStartOffset) {
          // Haven't reached start offset yet, keep at starting position
          this.scrollText.style.setProperty('--text-position', '5%');
          ticking = false;
          return;
        }
        
        // Calculate text position based on scroll
        // The text follows the viewport top edge
        const distanceFromViewportTop = scrolledIntoSection - scrollStartOffset;
        
        // Convert to percentage of section height
        let textPositionInSection = ((distanceFromViewportTop) / sectionHeight) * 100;
        
        // Start at 5%, but clamp to user-defined max position
        const startPos = 5;
        const maxPosPercent = scrollStopPosition;
        
        textPositionInSection = Math.max(startPos, Math.min(maxPosPercent, startPos + textPositionInSection));
        
        this.scrollText.style.setProperty('--text-position', `${textPositionInSection}%`);
        
        ticking = false;
      };
      
      const requestTick = () => {
        if (!ticking) {
          requestAnimationFrame(updateTextPosition);
          ticking = true;
        }
      };

      window.addEventListener('scroll', requestTick, { passive: true });
      window.addEventListener('resize', () => {
        requestTick();
      }, { passive: true });
      
      updateTextPosition(); // Initial position
    }

    showSecondaryMedia() {
      const primary = this.productMedia.querySelector('.product-media-wrapper--primary');
      const secondary = this.productMedia.querySelector('.product-media-wrapper--secondary');
      if (primary && secondary) {
        primary.style.opacity = '0';
        secondary.style.opacity = '1';
      }
    }

    hideSecondaryMedia() {
      const primary = this.productMedia.querySelector('.product-media-wrapper--primary');
      const secondary = this.productMedia.querySelector('.product-media-wrapper--secondary');
      if (primary && secondary) {
        primary.style.opacity = '1';
        secondary.style.opacity = '0';
      }
    }
  }

  customElements.define('product-highlight-section', ProductHighlightSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["three-column-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.three-column-cards-section .animate-on-scroll');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('animated');
          }, index * 150);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    cards.forEach(card => observer.observe(card));
  });

  } catch(e) { console.error(e); }
})();
})();
